/**
 * Logo Component
 * Displays FlowVerify AI logo with text
 */

import React from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
}

export const Logo = ({ className = '', showText = true }: LogoProps) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Logo Icon - 4 circles with star in center */}
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <path d="M5.86475 11.5016C5.92191 12.8928 6.48134 14.2674 7.54346 15.3297C8.63667 16.4229 10.0611 16.9816 11.4937 17.0104C11.558 18.5608 10.9996 20.1322 9.81592 21.316C7.57036 23.5616 3.92967 23.5615 1.68408 21.316C-0.561501 19.0704 -0.561501 15.4298 1.68408 13.1842C2.8361 12.0323 4.35513 11.4716 5.86475 11.5016ZM17.353 11.5016C18.7901 11.5271 20.2193 12.0876 21.3159 13.1842C23.5615 15.4298 23.5615 19.0704 21.3159 21.316C19.0703 23.5616 15.4297 23.5616 13.1841 21.316C12.0006 20.1325 11.4413 18.5615 11.5054 17.0113C13.0116 17.0386 14.5269 16.4791 15.6763 15.3297C16.7384 14.2674 17.2958 12.8928 17.353 11.5016ZM11.5044 5.51622C11.4418 7.06467 12.0019 8.63381 13.1841 9.81602C14.3333 10.9652 15.848 11.5237 17.354 11.4967C17.3539 11.4983 17.3531 11.4999 17.353 11.5016C15.8473 11.4748 14.3331 12.0352 13.1841 13.1842C12.1221 14.2462 11.5628 15.6204 11.5054 17.0113C11.5015 17.0113 11.4976 17.0104 11.4937 17.0104C11.4359 15.6198 10.8776 14.2459 9.81592 13.1842C8.72238 12.0906 7.29778 11.5301 5.86475 11.5016C5.86468 11.4999 5.86481 11.4983 5.86475 11.4967C7.29776 11.4682 8.72239 10.9095 9.81592 9.81602C10.9982 8.63379 11.5562 7.0647 11.4937 5.51622C11.4972 5.51615 11.5008 5.51628 11.5044 5.51622ZM1.68408 1.68419C3.92967 -0.561396 7.57033 -0.561396 9.81592 1.68419C10.8791 2.7475 11.4374 4.12357 11.4937 5.51622C10.061 5.54501 8.63668 6.10463 7.54346 7.19786C6.36156 8.37982 5.80244 9.94859 5.86475 11.4967C4.35516 11.5267 2.8361 10.9679 1.68408 9.81602C-0.561497 7.57044 -0.561489 3.92977 1.68408 1.68419ZM13.1841 1.68419C15.4297 -0.561396 19.0703 -0.561396 21.3159 1.68419C23.5614 3.92978 23.5615 7.57047 21.3159 9.81602C20.2196 10.9123 18.7907 11.4709 17.354 11.4967C17.4163 9.94857 16.8582 8.37983 15.6763 7.19786C14.5266 6.04823 13.011 5.48874 11.5044 5.51622C11.5607 4.12351 12.1208 2.74753 13.1841 1.68419Z" fill="url(#paint0_linear_8_163)"/>
        <defs>
        <linearGradient id="paint0_linear_8_163" x1="11.4999" y1="-0.000383377" x2="11.4999" y2="23.0005" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0D12FF"/>
        <stop offset="1" stop-color="#080B99"/>
        </linearGradient>
        </defs>
        </svg>
      
      {showText && (
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-800 text-lg">QC Agent</span>
          <span className="font-normal text-gray-600 text-lg">AI</span>
        </div>
      )}
    </div>
  );
};
